import { getDsList } from "../lib/dsApi";
import { DSSplitContentGroup } from "../lib/types";

// TODO check or remove
export const isSplitContentGroup = (
  data: Awaited<ReturnType<typeof getDsList>>["data"]
): data is Awaited<ReturnType<typeof getDsList>>["data"] & { data: [DSSplitContentGroup] } => {
  if (Array.isArray(data)) {
    return false;
    // return data.length === 1 && data[0].type === ContentGroupType.Split && "viewport_size" in data[0];
  }
  if (data.layout_config) {
    return true;
  }
  return false;
};
